export const EVENT_LABEL_TYPES = Object.freeze({
    ALWAYS_ON: 'always_on',
    BESPOKE_C1: 'bespoke'
});